import {
    DEALERCHECKLIST_SUCCESS,
    DEALERCHECKLIST_FAILED,
    RESET_DEALERCHECKLIST,
    LOADING_DEALERCHECKLIST,
    NETWORK_ERROR_DEALERCHECKLIST
} from "../types/index";
import { dealerServices } from "../../config/axios";

const resetDealerCheckList = () => {
    return { type: RESET_DEALERCHECKLIST };
};

const dealerCheckList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERCHECKLIST });
    await dealerServices
        .post("checkList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerCheckListsuccess(res.data));
                    break;
                default:
                    dispatch(dealerCheckListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERCHECKLIST,
                payload: err
            });
        });
};

function dealerCheckListsuccess(data) {
    return {
        type: DEALERCHECKLIST_SUCCESS,
        payload: data
    };
}
function dealerCheckListFailed(data) {
    return {
        type: DEALERCHECKLIST_FAILED,
        payload: data
    };
}

export { resetDealerCheckList, dealerCheckList }